import { QueryFilters, useActiveResourcesFull, useActiveUsersFull } from '../../api';
import { EntityDetails } from '../../types';
import { useState } from 'react';
import TopMetricsChart from '../../../../components/TopMetricsChart/TopMetricsChart';
import { PreviewItem } from '../../../../components/TopMetricsChart/types';
import { PROTECTED_ENTITY_BADGE_PROPS, UNPROTECTED_ENTITY_BADGE_PROPS } from '../../consts';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

export type EntityType = 'users' | 'resources';

interface Props {
    title: string;
    filters: QueryFilters;
    onInvestigationClick: (guid: string) => void;
    entities?: EntityDetails[];
    entitiesIsLoading: boolean;
    entityType: EntityType;
}

const TopEntityChart = ({
    title,
    filters,
    onInvestigationClick,
    entities = [],
    entitiesIsLoading,
    entityType
}: Props) => {
    const [showMore, setShowMore] = useState(false);

    const { data: usersFull = [], isLoading: usersFullIsLoading } = useActiveUsersFull(
        filters,
        showMore && entityType === 'users'
    );
    const { data: resourcesFull = [], isLoading: resourcesFullIsLoading } = useActiveResourcesFull(
        filters,
        showMore && entityType === 'resources'
    );

    const entitiesFull = entityType === 'users' ? usersFull : resourcesFull;
    const entitiesFullIsLoading = entityType === 'users' ? usersFullIsLoading : resourcesFullIsLoading;

    const handleShowMore = () => {
        setShowMore(true);
    };

    const handleInvestigationClick = (guid: string) => {
        onInvestigationClick(guid);
    };

    const timeframe = `last ${filters.timeframe} days`;

    const previewData: PreviewItem[] = entities.map(({ isProtected, ...data }) => ({
        ...data,
        badgeProps: isProtected ? PROTECTED_ENTITY_BADGE_PROPS : UNPROTECTED_ENTITY_BADGE_PROPS
    }));

    const fullData = entitiesFull.map(({ isProtected, ...data }) => ({
        ...data,
        metadata: {
            isProtected,
            adType: entityType === 'users' ? AD_ENTITY_TYPES.USER : AD_ENTITY_TYPES.SERVER
        }
    }));

    return (
        <TopMetricsChart
            label={title}
            data={previewData}
            fullData={fullData}
            loading={entitiesIsLoading}
            fullLoading={entitiesFullIsLoading}
            disabled={entities.length === 0}
            emptyStateConfig={{
                title: `No ${entityType} yet`,
                description: `No ${entityType} have been active in the last ${timeframe}`
            }}
            onInvestigationClick={handleInvestigationClick}
            onShowMore={handleShowMore}
        />
    );
};

export default TopEntityChart;
